import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import {
  COMMON_PERMISSIONS,
  MODULES_LIST,
  SUB_MODULES_LIST,
} from "../../../utils/helper";
import ManageDepartment from "../../main/configuration/manageDepartment/page";
import ManageDesignation from "../../main/configuration/manageDesignation/page";
import ManageTeam from "../../main/configuration/manageTeam/page";
import TeamDetail from "../../main/configuration/manageTeam/detail/page";
import CommonRoute from "../commonRoute";
import ManageLeaveSetup from "../../main/configuration/manageLeaveSetup/page";
import ManageBranch from "../../main/configuration/manageBranch/page";
import Role from "../../main/configuration/manageRole/page";
import AddRole from "../../main/configuration/manageRole/addRole";

const basicRoute = [
  {
    path: "/configuration",
    element: <CommonRoute />,
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: null,
  },
  
  {
    path: "/configuration/manage-departments",
    element: <ManageDepartment />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    subModule: SUB_MODULES_LIST.BASIC_SETUP.DEPARTMENT,
  },
  {
    path: "/configuration/manage-designation",
    element: <ManageDesignation />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    subModule: SUB_MODULES_LIST.BASIC_SETUP.DESIGNATION,
  },
  {
    path: "/configuration/manage-team",
    element: <ManageTeam />,
    access: [COMMON_PERMISSIONS.VIEW],
    // Treat Teams as part of HR module for permissions
    module: "hr",
    subModule: "team",
  },
  {
    path: "/configuration/manage-team/detail/:id",
    element: <TeamDetail />,
    access: [COMMON_PERMISSIONS.VIEW],
    // Same HR/team permission as list page
    module: "hr",
    subModule: "team",
  },
 {
    path: "/configuration/role",
    element: <Role />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    subModule: SUB_MODULES_LIST.BASIC_SETUP.ROLE,
  },
  {
    path: "/configuration/role/add",
    element: <AddRole />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    subModule: SUB_MODULES_LIST.BASIC_SETUP.ROLE,
  },
  {
    path: "/configuration/role/edit/:id",
    element: <AddRole />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    subModule: SUB_MODULES_LIST.BASIC_SETUP.ROLE,
  },
  // {
  //   path: "/configuration/role",
  //   element: <Role />,
  //   // access: [COMMON_PERMISSIONS.VIEW],
  //   // module: MODULES_LIST.BASIC_SETUP,
  //   // subModule: SUB_MODULES_LIST.BASIC_SETUP.DESIGNATION,
  // },
  {
    path: "/configuration/leave-setup",
    element: <ManageLeaveSetup />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE_TYPE,
  },
  {
    path: "/configuration/manage-branch",
    element: <ManageBranch />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.BRANCH, // No branch submodule defined
  },
  
];

export default function renderBasicRoutes() {
  const renderRoute = (route, access = false) => {
    if (route.children && route.children.length > 0) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
            >
             
            </ProtectedRoute>
          }
        >
          {/* Render child routes without extra permission checks */}
          {route.children.map((child) => (
            <Route key={child.path} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return basicRoute.map((route) => renderRoute(route));
}
